import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum HolidayProgramType {
  HOLIDAY = 'HOLIDAY',
  HOLIDAY_AT_HOME = 'HOLIDAY_AT_HOME',
}

@Component({
  selector: 'app-holiday-mode-select',
  templateUrl: './holiday-mode-select.component.html',
  styleUrls: ['./holiday-mode-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HolidayModeSelectComponent {
  readonly holidayProgramType = HolidayProgramType;

  @Output() cancelSettingHolidayProgram: EventEmitter<void> = new EventEmitter<void>();
  @Output() submitSelectedHolidayType: EventEmitter<HolidayProgramType> = new EventEmitter<
    HolidayProgramType
  >();

  selectedHolidayType: HolidayProgramType;

  constructor(public translation: TranslateService) {}

  onCancel(): void {
    this.cancelSettingHolidayProgram.emit();
  }

  goToNextStage(): void {
    this.submitSelectedHolidayType.emit(this.selectedHolidayType);
  }
}
